import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import Title from "../general/title"
import _ from "lodash"
import clone from "clone"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import submitData from "helpers/submitData"
import { loadingStatus } from "actions"
import settings from "settings"

const CommunityManagement = (props) => {
	const dispatch = useDispatch()
	const payload = useSelector((state) => state.payload)
	const payloadStatus = useSelector((state) => state.payloadStatus)
	const [fullData, setFullData] = useState([])

	useEffect(() => {
		if (payloadStatus) {
			pullCommunities()
		}
	}, [payloadStatus])

	const setLoadingStatus = (status) => {
		dispatch(loadingStatus(status))
	}

	const pullCommunities = async () => {
		setLoadingStatus(true)
		let resp = await submitData("mainRetrieve", {
			action: "getAllCommunities",
		})
		if (resp.status === 200) {
			setFullData(resp.data)
			setLoadingStatus(false)
		}
	}

	const columns = [
		{
			Header: "ID",
			accessor: "id",
		},
		{
			Header: "Community",
			accessor: "community",
			filterMethod: (f, r) => helpers.tableText(f, r, "community"),
		},
		...(settings?.lotContracts
			? [
					{
						Header: "Development Services Agreement",
						accessor: "development_services_agreement",
					},
					{
						Header: "Current Loan Agreement",
						accessor: "current_loan_agreement",
					},
			  ]
			: []),
		{
			Header: "Edit",
			accessor: "edit",
		},
	]

	const buildTable = () => {
		let data = []
		_.forEach(fullData, (v) => {
			let p = clone(v)
			p.community = p.name
			p.id = v.id
			if (settings?.lotContracts) {
				if (v?.finance_data?.development_services_agreement) {
					p.development_services_agreement = (
						<a href={settings.s3 + v.finance_data.development_services_agreement}>
							<i className="fa-solid fa-eye"></i>
						</a>
					)
				}
				if (v?.finance_data?.current_loan_agreement) {
					p.current_loan_agreement = (
						<a href={settings.s3 + v.finance_data.current_loan_agreement}>
							<i className="fa-solid fa-eye"></i>
						</a>
					)
				}
			}
			p.edit = (
				<Link to={`/admin/communities/${p.id}`}>
					<i className="far fa-edit"></i>
				</Link>
			)
			data.push(p)
		})
		return data
	}

	if (!payloadStatus) return null

	return (
		<div className="admin">
			<Title title="Communities Management" showDate={false} />
			<div className="content">
				<div className="admin__add">
					<Link to={"/admin/communities/add"}>
						<i className="fas fa-plus-circle" />
					</Link>
				</div>
				<FullTable
					data={buildTable()}
					columns={columns}
					name="communities"
					title="Communities"
					unset={["edit"]}
					pageSize={20}
					defaultSorted={[
						{
							id: "community",
							asc: true,
						},
					]}
				/>
			</div>
		</div>
	)
}

export default CommunityManagement
